import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import App from './App';
import store from 'store';

// style + assets
import 'assets/scss/style.scss';
import 'ui-components/jandi-links.css';
import 'ui-components/jandi-modal.css';
import 'ui-components/jandi-dialog.css';
import 'ui-components/jandi-buttons.css';
import 'ui-components/jandi-chips.css';
import 'ui-components/jandi-detail-grid.css';
import 'ui-components/jandi-utilities.css';
import 'ui-components/jandi-screens.css';
import 'ui-components/jandi-file-drop.css';
import config from './config';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <App />
        </BrowserRouter>
    </Provider>
);
